<template>
	<div class="partidaFormHeader puiformheader">
	</div>
</template>

<script>
import { PuiFormHeaderMixin } from '@Pui9Components';

export default {
	name: 'partida-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'partida'
		};
	},
	computed: {
	}
}
</script>
